import AccountFormulaNode from "../../../keyFigure/formula/AccountFormulaNode.js";
import AccountIntervalSpecification from "../../../accountSpecification/AccountIntervalSpecification.js";
import GroupRow from "./GroupRow.js";
import OrSpecification from "../../../specification/OrSpecification.js";

/**
 * Special row group used for defining a list of intervals
 * It is an ordinary group except it stores information about intervals it is created for.
 *
 * @param {object[]} spec.intervals - list of intervals
 */
export default class AccountIntervalGroupRow extends GroupRow {
	constructor({ intervals = [] }) {
		super(...arguments);
		this._intervals = intervals;
	}

	accept(visitor) {
		return visitor.visitAccountIntervalGroupRow(this);
	}

	asSpecification() {
		const intervalSpecifications = this._intervals.map(
			(interval) =>
				new AccountIntervalSpecification({
					interval: `${interval.start}-${interval.end}`,
				}),
		);

		return new OrSpecification({
			specifications: intervalSpecifications,
		});
	}

	_asBaseFormulaNode() {
		return this._makeAccountFormulaNode();
	}

	_makeAccountFormulaNode() {
		const accountNode = new AccountFormulaNode({
			accountSpecification: this.asSpecification(),
		});

		// Only leaves are negated. The account interval node is a leaf added
		// when making the formula node, so negate if needed.
		if (this.isNegated()) {
			return this._negatedFormulaNode(accountNode);
		}

		return accountNode;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.intervals = this._intervals;

		return properties;
	}

	static getType() {
		return "AccountIntervalGroupRow";
	}
}
